import React from 'react';
import { Table, DropdownButton, MenuItem } from 'react-bootstrap';
import { getUser } from '../../utils/Common';
import { getReadableAccessLevel } from '../access-control/utils';

export default function GeneralSettingsPanel({
  user,
  toggleBuilderAdmin,
  toggleBillingAccess,
  handleAccessChangeRequest,
  isMobile,
  builder
}) {
  return (
    <section className="access-control-panel">
      <h2 className="access-control-section-title access-control-section-title--spaced">
        General User Settings
      </h2>
      <Table bordered condensed hover className="access-control-simple-table user-settings-table">
        <tbody>
          {getUser().userId === user.userId && (
            <tr>
              <td colSpan={2} className="user-settings-note">
                You cannot change your own access level
              </td>
            </tr>
          )}
          <tr>
            <td><strong>{builder.name} Admin</strong></td>
            <td>
              <div className="elegant-checkbox-container">
                <label className="elegant-checkbox">
                  <input
                    type="checkbox"
                    checked={user.builderStatus === 'ADMIN'}
                    onChange={toggleBuilderAdmin}
                    disabled={getUser().userId === user.userId}
                  />
                  <span className="elegant-checkbox-slider" />
                </label>
                <span>{user.builderStatus === 'ADMIN' ? 'Admin Access Enabled' : 'Admin Access Disabled'}</span>
              </div>
            </td>
          </tr>
          <tr>
            <td><strong>{builder.name} Billing</strong></td>
            <td>
              <div className="elegant-checkbox-container">
                <label className="elegant-checkbox">
                  <input
                    type="checkbox"
                    checked={user.builderStatus === 'BILLING' || user.builderStatus === 'ADMIN'}
                    onChange={toggleBillingAccess}
                    disabled={user.builderStatus === 'ADMIN'}
                  />
                  <span className="elegant-checkbox-slider" />
                </label>
                <span>
                  {user.builderStatus === 'ADMIN'
                    ? 'Included as a Builder Admin'
                    : user.builderStatus === 'BILLING'
                      ? 'Billing Access Enabled'
                      : 'Billing Access Disabled'}
                </span>
              </div>
            </td>
          </tr>
          <tr>
            <td><strong>Update Access to All Cameras</strong></td>
            <td className="user-settings-bulk-access">
              <DropdownButton
                title="Select Access Level"
                id="bulk-access-dropdown"
                className="access-tier-dropdown access-tier--select"
                onSelect={(newType) => handleAccessChangeRequest(user.userId, newType)}
                disabled={user.builderStatus === 'ADMIN'}
                bsSize={isMobile ? 'xs' : 'small'}
              >
                <MenuItem eventKey="No Access" className="access-tier--none">
                  {getReadableAccessLevel('No Access', null, isMobile)}
                </MenuItem>
                <MenuItem eventKey="DEMO" className="access-tier--demo">
                  {getReadableAccessLevel('DEMO', null, isMobile)}
                </MenuItem>
                <MenuItem eventKey="VIEWER" className="access-tier--viewer">
                  {getReadableAccessLevel('VIEWER', null, isMobile)}
                </MenuItem>
                <MenuItem eventKey="OWNER" className="access-tier--owner">
                  {getReadableAccessLevel('OWNER', null, isMobile)}
                </MenuItem>
                {getUser().role === 'ADMIN' && (
                  <MenuItem eventKey="SALES_DEMO" className="access-tier--sales-demo">
                    {getReadableAccessLevel('SALES_DEMO', null, isMobile)}
                  </MenuItem>
                )}
              </DropdownButton>
            </td>
          </tr>
        </tbody>
      </Table>
    </section>
  );
}
